"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppRoot = void 0;
/**
 * Copyright © 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const notistack_1 = require("notistack");
const utils_1 = require("../utils");
const clear_cache_1 = require("./clear-cache");
const constants_1 = require("../constants");
const utils_2 = require("./Snackbar/utils");
const components_1 = require("./Snackbar/components");
exports.AppRoot = (props) => {
    const { children } = props;
    return (react_1.default.createElement(material_1.StyledEngineProvider, { injectFirst: true },
        react_1.default.createElement(material_1.ThemeProvider, { theme: constants_1.themeOptions },
            react_1.default.createElement(material_1.CssBaseline, null),
            react_1.default.createElement(notistack_1.SnackbarProvider, { maxSnack: 3, anchorOrigin: utils_1.anchorOrigin, preventDuplicate: true, iconVariant: utils_2.iconVariants, Components: components_1.snackbarComponents, autoHideDuration: 5000 },
                react_1.default.createElement(clear_cache_1.ClearApplicationCache, null, children)))));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQXBwUm9vdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0FwcFJvb3QudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBOzs7Ozs7R0FNRztBQUNILGtEQUEwQjtBQUMxQiw0Q0FBaUY7QUFDakYseUNBQTZDO0FBRTdDLG9DQUF3QztBQUN4QywrQ0FBc0Q7QUFDdEQsNENBQTRDO0FBQzVDLDRDQUFnRDtBQUNoRCxzREFBMkQ7QUFFOUMsUUFBQSxPQUFPLEdBQUcsQ0FBQyxLQUFtQyxFQUFFLEVBQUU7SUFDN0QsTUFBTSxFQUFFLFFBQVEsRUFBRSxHQUFHLEtBQUssQ0FBQztJQUMzQixPQUFPLENBQ0wsOEJBQUMsK0JBQW9CLElBQUMsV0FBVztRQUMvQiw4QkFBQyx3QkFBYSxJQUFDLEtBQUssRUFBRSx3QkFBWTtZQUNoQyw4QkFBQyxzQkFBVyxPQUFHO1lBQ2YsOEJBQUMsNEJBQWdCLElBQ2YsUUFBUSxFQUFFLENBQUMsRUFDWCxZQUFZLEVBQUUsb0JBQVksRUFDMUIsZ0JBQWdCLFFBQ2hCLFdBQVcsRUFBRSxvQkFBWSxFQUN6QixVQUFVLEVBQUUsK0JBQWtCLEVBQzlCLGdCQUFnQixFQUFFLElBQUk7Z0JBRXRCLDhCQUFDLG1DQUFxQixRQUFFLFFBQVEsQ0FBeUIsQ0FDeEMsQ0FDTCxDQUNLLENBQ3hCLENBQUM7QUFDSixDQUFDLENBQUMifQ==